"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mui_1 = require("tss-react/mui");
const Box_1 = __importDefault(require("@mui/material/Box"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const useOfxShadowAccountInfoDialog_1 = __importDefault(require("components/OfxShadowAccountInfo/useOfxShadowAccountInfoDialog"));
const styles_1 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.default);
const OfxShadowAccountBanner = ({ onClose }) => {
    const { classes } = useStyles();
    const openOfxShadowAccountInfoDialog = (0, useOfxShadowAccountInfoDialog_1.default)();
    return (<Box_1.default id="ofx-shadow-account-banner" className={classes.root}>
      <Box_1.default className={classes.content}>
        <Typography_1.default id="ofx-shadow-account-banner-text" variant={'body1'} className={classes.text}>
          {'This account updates from Quicken Desktop'}
        </Typography_1.default>
        <IconButton_1.default id="ofx-shadow-account-banner-info" aria-label={'Account update info'} size="small" className={classes.iconButton} onClick={openOfxShadowAccountInfoDialog}>
          <InfoOutlined_1.default className={classes.icon}/>
        </IconButton_1.default>
      </Box_1.default>
      <IconButton_1.default id="ofx-shadow-account-banner-close" aria-label={'Dismiss banner'} size="small" className={classes.iconButton} onClick={onClose}>
        <Close_1.default className={classes.icon}/>
      </IconButton_1.default>
    </Box_1.default>);
};
exports.default = OfxShadowAccountBanner;
